import React from 'react';
import {connect} from 'react-redux';
import {Card, Loader, Table} from 'semantic-ui-react';
import moment from 'moment';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {reverseShortDate} from '../../../common/constants/datesFormat';
import VehiclesTable from './vehiclesTable';
import {getColumns} from './vehiclesTableColumns';
import '../dispatchOrdersStyles.scss';
import {navigateTo} from '../../../router/actions';

class DispatchOrdersApprovals extends React.Component {
  constructor(props) {
    super(props);
    this.reactTable = null;
    this.setReactTableRef = (element) => {
      element ?
        this.reactTable = element :
        null;
    };
    this.state = {
      'filtered': [],
      'filteredData': [],
      'table': '',
      'columns': getColumns(),
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.DispatchOrdersApproval, scopes.Approve)) {
      navigateTo(paths.AccessDenied);
    }
    this.props.fetchDispatchOrdersList('E');
  }

  onFilteredChangeCustom = (value, accessor) => {
    const filtered = this.state.filtered;
    let insertNewFilter = 1;

    if (filtered.length) {
      filtered.forEach((filter, i) => {
        if (filter.id === accessor) {
          if (value === '' || !value.length) {
            filtered.splice(i, 1);
          } else {
            filter.value = value;
          }
          insertNewFilter = 0;
        }
      });
    }

    if (insertNewFilter) {
      filtered.push({'id': accessor, 'value': value});
    }
    this.setState({'filtered': filtered});
  };
    
  render() {
    const {columns} = this.state;
    const {dispatchOrdersList, loading} = this.props;
    return (
      <div className='set-sales-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Órdenes de Despacho - Aprobación</h2>
            </div>
          </div>
        </Card>
        <Card raised fluid>
          {loading ?
            <Table>
              <Table.Body>
                <Table.Row className='loader'>
                  <Table.Cell colSpan='100%'>
                    <Loader active inline='centered' />
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table> :
            <VehiclesTable tableColumns={columns} tableData={dispatchOrdersList} />
          }
        </Card>
      </div>
    );
  }
}

const {
  fetchDispatchOrdersList,
  fetchDispatchOrder,
} = Actions;
  
const mapDispatchToProps = {
  fetchDispatchOrdersList,
  fetchDispatchOrder,
};

const mapStateToProps = (state) => {
  const dispatchOrdersList = state.dispatchOrders.dispatchOrdersList;
  const dispatchOrdersListFormatted = dispatchOrdersList ? dispatchOrdersList.map((x) => {
    return {
      ...x,
      'anticipatedInvoice': x.anticipatedInvoice === 'N' ? 'NO' : 'SI',
      'addDate': moment(x.addDate).format(reverseShortDate),
      'updateDate': moment(x.updateDate).format(reverseShortDate),
    };
  }) : [];
  return {
    'permissions': state.session.permissions,
    'dispatchOrdersList': dispatchOrdersListFormatted,
    'loading': state.dispatchOrders.loading,
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(DispatchOrdersApprovals);
